{"id":"GooglePlay","prefabs":{"default":{"children":[{"component":"GooglePlay","options":"options:*"}]}}}